import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-lazy]";

        function lazyLoad() {
            if ($(selector).length) {
                var log = typeof debug !== "undefined";
                if (log) console.log("%cfunction_lazy-load.js initialized", "color: green;");

                var observer = new IntersectionObserver(
                    (entries, obs) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                var $el = $(entry.target);
                                var data = {
                                    sizes: $el.attr("data-sizes") || Math.round($el.width()) + "px",
                                    srcset: $el.attr("data-srcset") || $el.attr("srcset"),
                                    src: $el.attr("data-src") || $el.attr("src"),
                                    type: $el.attr("data-type") || $el.attr("type"),
                                };

                                if ($el.is("img")) {
                                    $el.attr({
                                        sizes: data.sizes,
                                        srcset: data.srcset,
                                        src: data.src,
                                    }).removeAttr("data-sizes data-srcset data-src data-lazy");
                                }

                                if ($el.is("video")) {
                                    $el.attr({
                                        src: data.src,
                                        type: data.type,
                                    }).removeAttr("data-src data-type data-lazy");
                                    $el[0].load();
                                }

                                if ($el.is("lottie-player")) {
                                    if (!window.LottiePlayer) return;
                                    $el.attr("src", data.src).removeAttr("data-src data-lazy");
                                    $el[0].load(data.src);
                                }

                                $(window).trigger("fetchSuccess");
                                obs.unobserve($el[0]);
                            }
                        });
                    },
                    {
                        rootMargin: "100px 0px",
                        threshold: 0.01,
                    }
                );

                $(selector).each(function () {
                    observer.observe($(this)[0]);
                });
            }
        }

        lazyLoad();
        $(window).on("fetchSuccess", lazyLoad);
    });
})();
